import { defineComponent as a, mergeModels as n, useModel as d, openBlock as k, createElementBlock as c, normalizeClass as b, renderSlot as r, createElementVNode as i, withModifiers as p, createCommentVNode as f, pushScopeId as m, popScopeId as h } from "vue";
import { _ as g } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
import './assets/BaseToggle.css';const w = (t) => (m("data-v-1e6f488b"), t = t(), h(), t), _ = { class: "switch uikit-relative uikit-inline-block uikit-min-w-[40px] uikit-text-sm" }, y = ["data-cy", "checked"], v = /* @__PURE__ */ w(() => /* @__PURE__ */ i("span", { class: "slider round uikit-absolute uikit-bottom-0 uikit-left-0 uikit-right-0 uikit-top-0 uikit-cursor-pointer uikit-bg-w-lavender uikit-duration-300 before:uikit-absolute before:uikit-bottom-0 before:uikit-left-0 before:uikit-top-0 before:uikit-box-border before:uikit-h-[22px] before:uikit-w-[22px] before:uikit-rounded-circle before:uikit-border before:uikit-border-solid before:uikit-border-w-secondary before:uikit-bg-white before:uikit-shadow-sm before:uikit-duration-300 before:uikit-content-[''] peer-checked/toggle:uikit-bg-w-primary" }, null, -1)), B = ["innerHTML"], L = /* @__PURE__ */ a({
  inheritAttrs: !1,
  __name: "BaseToggle",
  props: /* @__PURE__ */ n({
    withRightLabel: { type: Boolean, default: !0 },
    label: { default: "" }
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const o = d(t, "modelValue"), u = ({ target: e }) => {
      o.value = e.checked;
    };
    return (e, l) => (k(), c("div", {
      class: b(["switch-container uikit-inline-block uikit-items-center", e.$attrs.class])
    }, [
      r(e.$slots, "leftLabel", {}, void 0, !0),
      i("label", _, [
        i("input", {
          "data-cy": e.$attrs["data-cy"] ?? "",
          class: "uikit-peer/toggle uikit-h-0 uikit-w-0 uikit-opacity-0",
          type: "checkbox",
          checked: o.value,
          onInput: l[0] || (l[0] = p((s) => u(s), ["stop"]))
        }, null, 40, y),
        v
      ]),
      e.withRightLabel ? r(e.$slots, "rightLabel", { key: 0 }, () => [
        i("span", {
          class: "uikit-ml-10px",
          innerHTML: e.label
        }, null, 8, B)
      ], !0) : f("", !0)
    ], 2));
  }
}), I = /* @__PURE__ */ g(L, [["__scopeId", "data-v-1e6f488b"]]);
export {
  I as default
};
